import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material';
import { tertiaryHoverSx } from '../../styles/Global.style';

export const Close = ({ size = 'large' }) => {
  const theme = useTheme();

  return <CloseIcon fontSize={size} sx={tertiaryHoverSx(theme)} />;
};
